import React, { Component, Suspense } from "react";
import { createBrowserHistory } from "history";

import "./Header.scss";
import axios from "axios";
import Icon from "react-icons-kit";
import { userCircleO } from "react-icons-kit/fa/userCircleO";
import JejakinLogo from "./../../../images/jejakin-marketplace.svg";
import JejakinLogoIcon from "./../../../images/jejakin-marketplace-icon.svg";
import HeaderAccount from "./HeaderAccount";
import HeaderDropdown from "./HeaderDropdown";
import HeaderLink from "./HeaderLink";

import { Translation } from "react-i18next";
import ButtonOffset from "../Button/ButtonOffset";
import { Link } from "react-router-dom";
import Autosuggest from "react-autosuggest";
import { debounce } from "lodash";
import HeaderDropdownPublic from "./HeaderDropdownPublic";
import { withTranslation } from "react-i18next";

const getSuggestionValue = (suggestion) => suggestion.title;

// Use your imagination to render suggestions.
const renderSuggestion = (suggestion) => (
  <div className="suggestion-program">
    <span className="program-name">{suggestion.title}</span>
  </div>
);

class HeaderGeneral extends Component {
  state = {
    loggedIn: false,
    isAuth: null,
    name: null,
    initialName: "J",
    hexaColor: "c8d6e5",
    dropdownAcc: false,
    dropdownAccPublic: false,
    value: "",
    suggestions: [],
    programIdTree: null,
    programIdCarbon: null,
  };
  componentDidMount() {
    console.log("this.props.location ", this.props.location);
    const userData = localStorage.getItem("userData");
    if (userData) {
      this.setState({
        loggedIn: true,
        name: JSON.parse(userData).data.companyName,
        userType: JSON.parse(userData).data.userType,
        initialName: localStorage.getItem("initialName"),
        hexaColor: localStorage.getItem("hexaColor"),
      });
      var configHeader = {
        headers: {
          "Content-Type": "application/json",
          token: JSON.parse(userData).token,
        },
      };
      axios
        .get(process.env.REACT_APP_API_HOST + "/check-token", configHeader)
        .then((res) => {
          console.log("res token ", res.data);
          if (res.data.error.length !== 0) {
            if (res.data.error[0].errorMessage === "TokenExpired") {
              console.log("error message ");
              setTimeout(() => {
                window.location.href = "/logout";
              }, 100);
            }
          }
        });
    } else {
      var configHeader = {
        headers: {
          "Content-Type": "application/json",
          token: "",
        },
      };
    }
    axios
      .get(process.env.REACT_APP_API_HOST + "/session", configHeader)
      .then((res) => {
        this.setState({ isAuth: res.data.isAuth });
      });
  }

  onChange = (event, { newValue }) => {
    console.log("newValue onchange", newValue);
    this.setState({
      value: newValue,
    });
  };

  onSuggestionSelectedTree = (
    event,
    { suggestion, suggestionValue, index, method }
  ) => {
    event.preventDefault();
    console.log("tree suggestion ", suggestionValue);
    this.setState({
      programIdTree: suggestionValue,
    });
    setTimeout(function () {
      window.location.href = "/program/tree?id=" + suggestion.id + '&' + window.location.href.split('?')[1];
    }, 200);
  };

  onSuggestionSelectedCarbon = (
    event,
    { suggestion, suggestionValue, index, method }
  ) => {
    event.preventDefault();
    console.log("carbon suggestion ", suggestionValue);
    this.setState({
      programIdCarbon: suggestionValue,
    });
    setTimeout(function () {
      window.location.href = "/program/carbon?id=" + suggestion.id;
    }, 200);
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequestedTree = ({ value }) => {
    this.fetchedDBProgramTree(value);
  };
  fetchedDBProgramTree = debounce((value) => {
    console.log("value fetched tree ", value);
    console.log("value onSuggestionsFetchRequested", value);
    axios
      .get(
        process.env.REACT_APP_API_HOST + "/program/search/tree?search=" + value
      )
      .then((res) => {
        console.log("get program db ", res.data);
        if (res.data.status === true) {
          this.setState({ suggestions: res.data.data });
        } else {
          this.setState({
            status: false,
            error: res.data.error,
            loading: false,
          });
        }
      });
  }, 400);

  onSuggestionsFetchRequestedCarbon = ({ value }) => {
    this.fetchedDBProgramCarbon(value);
  };
  fetchedDBProgramCarbon = debounce((value) => {
    console.log("value fetched Carbon ", value);
    console.log("value onSuggestionsFetchRequested", value);
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/program/search/carbon?search=" +
          value
      )
      .then((res) => {
        console.log("get program db ", res.data);
        if (res.data.status === true) {
          this.setState({ suggestions: res.data.data });
        } else {
          this.setState({
            status: false,
            error: res.data.error,
            loading: false,
          });
        }
      });
  }, 400);

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    console.log("value onSuggestionsClearRequested");
    this.setState({
      suggestions: [],
    });
  };

  callbackDropdown = (dataFromChild) => {
    console.log("fromchild", dataFromChild);
    this.setState({
      dropdownAcc: dataFromChild,
      dropdownAccPublic: dataFromChild,
    });
  };

  render() {
    const { value, suggestions } = this.state;
    // Autosuggest will pass through all these props to the input.
    const inputPropsTree = {
      placeholder: this.props.t("HeaderGeneral.placeholder_search"),
      value,
      onChange: this.onChange,
    };
    const inputPropsCarbon = {
      placeholder: this.props.t("HeaderGeneral.placeholder_search"),
      value,
      onChange: this.onChange,
    };

    const history = createBrowserHistory();
    const userData = localStorage.getItem("userData");
    let headerPartial;
    let logoHeader;
    let headerDropdown;
    if (userData) {
      logoHeader = (
        <img src={JejakinLogoIcon} className="logo-icon" alt="Jejak" />
      );
      if (this.state.loggedIn || this.state.isAuth === "1") {
        headerPartial = (
          <HeaderAccount
            name={JSON.parse(userData).data.companyName}
            userType={JSON.parse(userData).data.userType}
            isAuth={this.state.isAuth}
            dropdownAcc={this.state.dropdownAcc}
            useSuspense={false}
          />
        );
        headerDropdown = (
          <HeaderDropdown
            name={JSON.parse(userData).data.companyName}
            userType={JSON.parse(userData).data.userType}
            isAuth={this.state.isAuth}
            dropdownAcc={this.state.dropdownAcc}
            hexaColor={this.state.hexaColor}
            initialName={this.state.initialName}
            callbackFromParent={this.callbackDropdown}
            useSuspense={false}
          />
        );
      }
    } else {
      logoHeader = (
        <img src={JejakinLogoIcon} className="logo-icon" alt="Jejak" />
      );
      headerPartial = <div> 
          <Suspense fallback="...Loading">
            <Translation>
                {(t) => ( <h3 style={{marginTop:'22px'}}><Link className="link-menu" to="/term-conditions">{t("TermCondition.title")}</Link></h3>  )
            }
            </Translation>
          </Suspense>
        </div>;
      headerDropdown = (
        <HeaderDropdownPublic
          dropdownAccPublic={this.state.dropdownAccPublic}
          callbackFromParent={this.callbackDropdown}
          useSuspense={false}
        />
      );
    }

    return (
      <div className="header">
        <div className="nav nav-main-top shadow-bottom sticky-top-nav">
          <div className="nav-jejak">
            <div className="nv-col nv-col-side">
              <div className="logo-img">
                <a href="/">{logoHeader}</a>
              </div>
            </div>
            <div className="nv-col nv-col-center nv-col-wide">
              <div className="container">
                <div className="row align-items-center">
                  {history.location.pathname === "/tree" ? (
                    <div className="col">
                      <div className="nav-headbar">
                        <div className="wrapper-search">
                          <Autosuggest
                            suggestions={suggestions}
                            onSuggestionsFetchRequested={
                              this.onSuggestionsFetchRequestedTree
                            }
                            onSuggestionsClearRequested={
                              this.onSuggestionsClearRequested
                            }
                            onSuggestionSelected={this.onSuggestionSelectedTree}
                            getSuggestionValue={getSuggestionValue}
                            renderSuggestion={renderSuggestion}
                            inputProps={inputPropsTree}
                          />
                        </div>
                        {/* <ButtonOffset whatOffset="tree" /> */}
                      </div>
                    </div>
                  ) : (
                    <div className="col">
                      {history.location.pathname === "/carbon" ? (
                        <div className="nav-headbar">
                          <div className="wrapper-search">
                            <Autosuggest
                              suggestions={suggestions}
                              onSuggestionsFetchRequested={
                                this.onSuggestionsFetchRequestedCarbon
                              }
                              onSuggestionsClearRequested={
                                this.onSuggestionsClearRequested
                              }
                              onSuggestionSelected={
                                this.onSuggestionSelectedCarbon
                              }
                              getSuggestionValue={getSuggestionValue}
                              renderSuggestion={renderSuggestion}
                              inputProps={inputPropsCarbon}
                            />
                          </div>
                          {/* <ButtonOffset whatOffset="carbon" /> */}
                        </div>
                      ) : (
                        <React.Fragment>
                          {history.location.pathname === "/program/tree" ? (
                            <div className="nav-headbar">
                              <div className="wrapper-search">
                                <Autosuggest
                                  suggestions={suggestions}
                                  onSuggestionsFetchRequested={
                                    this.onSuggestionsFetchRequestedTree
                                  }
                                  onSuggestionsClearRequested={
                                    this.onSuggestionsClearRequested
                                  }
                                  onSuggestionSelected={
                                    this.onSuggestionSelectedTree
                                  }
                                  getSuggestionValue={getSuggestionValue}
                                  renderSuggestion={renderSuggestion}
                                  inputProps={inputPropsTree}
                                />
                              </div>
                              {/* <ButtonOffset whatOffset="tree" /> */}
                            </div>
                          ) : (
                            <React.Fragment>
                              {history.location.pathname ===
                              "/program/carbon" ? (
                                <div className="nav-headbar">
                                  <div className="wrapper-search">
                                    <Autosuggest
                                      suggestions={suggestions}
                                      onSuggestionsFetchRequested={
                                        this.onSuggestionsFetchRequestedCarbon
                                      }
                                      onSuggestionsClearRequested={
                                        this.onSuggestionsClearRequested
                                      }
                                      onSuggestionSelected={
                                        this.onSuggestionSelectedCarbon
                                      }
                                      getSuggestionValue={getSuggestionValue}
                                      renderSuggestion={renderSuggestion}
                                      inputProps={inputPropsCarbon}
                                    />
                                  </div>
                                  <ButtonOffset whatOffset="carbon" />
                                </div>
                              ) : (
                                <React.Fragment>{headerPartial}</React.Fragment>
                              )}
                            </React.Fragment>
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="nv-col nv-col-side">
            {headerDropdown}
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(HeaderGeneral);
